// Redux/Slices/MarketSegmentReportSlice.js

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { ReservationMarketsegmentReport } from "../../Services/Service";


export const fetchMarketSegmentReport = createAsyncThunk(
  "marketSegmentReport/fetch",
  async (params, { rejectWithValue }) => {
    try {
      const response = await ReservationMarketsegmentReport(params);
      return response;
    } catch (error) {
      return rejectWithValue(error.response?.data || "Error");
    }
  }
);

const marketSegmentReportSlice = createSlice({
  name: "marketSegmentReport",
  initialState: {
    data: [],
    loading: false,
    error: null,
  },
  reducers: {
    clearMarketSegment: (state) => {
      state.data = [];
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchMarketSegmentReport.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchMarketSegmentReport.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(fetchMarketSegmentReport.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { clearMarketSegment } = marketSegmentReportSlice.actions;
export default marketSegmentReportSlice.reducer;